import {createSelector} from 'reselect';
import props from './props';

export default createSelector(
    props.app.preloaded,
    props.app.loaded,
    props.user.loaded,
    props.user.isAuth,
    props.app.language,
    props.app.jackpots_loaded,
    (preloaded, loaded, user_loaded, user_isAuth, language, jackpots_loaded) => {
        return {
            preloaded,
            loaded,
            user: {
                loaded: user_loaded,
                isAuth: user_isAuth,
            },
            language,
            jackpots_loaded
        }
    }
)